import React from 'react';
import { Plus, MessageCircle } from 'lucide-react';
import { useSectionMotion } from './motion';
import Frase from './Frase';
import { useIdioma, type Traducir } from '../../i18n/idioma';

/* Guarda CLAVES y no texto: este arreglo vive en el módulo, fuera del
   componente, y ahí no se puede llamar al hook del idioma. Se traduce al
   pintar, que además es lo que hace que cambie sin recargar. */
const PREGUNTAS = ['lp.faq.1', 'lp.faq.2', 'lp.faq.3', 'lp.faq.4', 'lp.faq.5', 'lp.faq.6'] as const;

/**
 * Preguntas frecuentes.
 *
 * Filetes en vez de seis cajas redondeadas apiladas. Seis tarjetas leen como
 * plantilla; seis renglones divididos por una línea leen como un documento —
 * que es exactamente lo que es.
 *
 * Va sobre `<details>` nativo a propósito: abre y cierra sin JavaScript, el
 * navegador ya lo anuncia bien a los lectores de pantalla, y el buscador
 * interno del navegador (Ctrl+F) encuentra el texto aunque esté cerrado.
 */
const Preguntas: React.FC = () => {
    const { t } = useIdioma();
    const scope = useSectionMotion<HTMLElement>(({ reveal, titular }) => {
        titular({ start: 'top 76%' });

        reveal('[data-fade]', { start: 'top 74%', stagger: 0.06 });
    });

    return (
        <section
            ref={scope}
            id="preguntas"
            className="rp-on-light bg-acero-100 px-5 py-[clamp(5rem,11vw,9rem)] sm:px-8"
        >
            <div className="mx-auto max-w-[1240px]">
                <div className="max-w-[820px]">
                    <h2 className="rp-h2 max-w-[16ch] text-navy-950">
                        <Frase marca="titular">{t('lp.faq.titular')}</Frase>
                    </h2>

                    <div className="mt-12">
                        {PREGUNTAS.map((clave) => (
                            <details key={clave} data-fade className="rp-faq group">
                                <summary>
                                    <span className="pr-2 text-[17px] font-bold tracking-tight text-navy-950 sm:text-[19px]">
                                        {t(`${clave}.q` as Parameters<Traducir>[0])}
                                    </span>
                                    <Plus
                                        aria-hidden="true"
                                        className="rp-faq__icon h-5 w-5 text-acero-500"
                                    />
                                </summary>
                                <p className="rp-body max-w-[62ch] pb-6 pr-8 text-acero-700">
                                    {t(`${clave}.a` as Parameters<Traducir>[0])}
                                </p>
                            </details>
                        ))}
                        <div className="border-t border-acero-200" />
                    </div>

                    <p data-fade className="mt-10 flex flex-wrap items-center gap-x-3 gap-y-2 text-[15px] text-acero-700">
                        {t('lp.faq.duda')}
                        <a
                            href="https://wa.me/14806700484"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="rp-link text-navy-950"
                        >
                            <MessageCircle className="h-4 w-4" aria-hidden="true" />
                            {t('lp.faq.whatsapp')}
                        </a>
                    </p>
                </div>
            </div>
        </section>
    );
};

export default Preguntas;
